import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { stripDocumentSeparators } from '@/shared/format/internal';

import { OPERATOR_STATUS_OPTIONS } from './bank-account-tabs.filters';
import { transferDateFilterParam } from './transfer.filters';

// Filtros da aba Pix (U3). Leve: entra no `validateSearch` da rota do detalhe. A tabela é a da TED
// (`TableTransferContainer.tsx:234-247`), com os mesmos cinco filtros e os mesmos nomes no fio. ⚠️ O legado
// dividia o `groupName` `BankAccountTransfer` com a aba Transferências, e o filtro de uma vazava para a outra;
// aqui a chave da URL é própria (`pix_*`).

export const pixListFilters = defineFilters([
  { key: 'pix_searchString', param: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'pix_transferDate', param: 'f_transferDate', type: 'date', label: msg`Data da ocorrência`, placeholder: msg`Filtrar por data da ocorrência`, toParam: transferDateFilterParam },
  { key: 'pix_beneficiaryName', param: 'f_beneficiaryName', type: 'text', label: msg`Favorecido`, placeholder: msg`Filtrar por favorecido` },
  {
    key: 'pix_beneficiaryRegistrationNumber',
    param: 'f_beneficiaryRegistrationNumber',
    type: 'document',
    label: msg`CPF/CNPJ`,
    placeholder: msg`Filtrar por CPF/CNPJ`,
    toParam: (raw: string) => stripDocumentSeparators(raw).toUpperCase(),
  },
  { key: 'pix_status', param: 'f_status', type: 'select', label: msg`Status`, options: OPERATOR_STATUS_OPTIONS },
]);
